import styled, { StyledProps } from 'styled-components/macro';

export type CellWidthStyledProps = StyledProps<{
  maxWidth?: number;
  width?: number;
}>;

export const CellWidthStyled = styled.div<CellWidthStyledProps>`
  min-width: 200px;
  max-width: ${(props) => `${props.maxWidth}px` ?? 'auto'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
